const compR = (rfn, fn) => [rfn[0], rfn[1], fn];
export {
  compR
};
